import * as yup from 'yup';

const requiredMessage: string = 'Vous devez accepter ce rappel pour créer votre compte et vos prochaines commandes.'

export const reminderSchema = yup.object().shape({
    first_reminder: yup.boolean().oneOf([true],requiredMessage),
    second_reminder: yup.boolean().oneOf([true],requiredMessage),
    third_reminder: yup.boolean().oneOf([true],requiredMessage),
    fourth_reminder: yup.boolean().oneOf([true],requiredMessage),
    fifth_reminder: yup.boolean().oneOf([true],requiredMessage),
    sixth_reminder: yup.boolean().oneOf([true],requiredMessage),
    seventh_reminder: yup.boolean().oneOf([true],requiredMessage)
})